export const getters = {
    getOrderedThemes: state => {
        return state.themes.sort((a, b) => a.order - b.order );
    },
    getThemeById: state => (_id) => state.themes.find(({ id }) => _id === id),
    getThemeLayerById: state => (themeId, layerId) => state.themes.find(({ id }) => id === themeId)?.data?.themeLayers.find(({ id }) => id === layerId),
    getThemeByName: state => (name) => {
        return state.themes.find(theme => theme.data.name === name);
    },
    getThemes: (state, _getters) => JSON.parse(JSON.stringify(_getters.getOrderedThemes)),
    getThemesData: (state, _getters) => JSON.parse(JSON.stringify(_getters.getOrderedThemes.map(({ data }) => data))),
    getThemeGroups: state => {
        return state.themeGroups.sort((a, b) => a.order - b.order);
    },
};
